/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_Defaultassigneeplaceholder2Inputs */

const en_cases_settings_category_defaultassigneeplaceholder2 = /** @type {(inputs: Cases_Settings_Category_Defaultassigneeplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No default assignee`)
};

/**
* | output |
* | --- |
* | "No default assignee" |
*
* @param {Cases_Settings_Category_Defaultassigneeplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_defaultassigneeplaceholder2 = /** @type {((inputs?: Cases_Settings_Category_Defaultassigneeplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Defaultassigneeplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_defaultassigneeplaceholder2(inputs)
});
export { cases_settings_category_defaultassigneeplaceholder2 as "cases_settings_category_defaultAssigneePlaceholder" }